/*
 * Builds a fontFamily CSS value with a same-category generic fallback
 * (serif / sans-serif / monospace), so text still renders with the right
 * general shape while a Google Font from config/fonts.js is loading or
 * if it fails to load.
 */
import fonts from '../config/fonts';

const DEFAULT_CATEGORY = 'sans-serif';

export const getFontFamilyStyle = (fontFamily) => {
  if (!fontFamily) return '';
  const font = fonts.find((f) => f.font === fontFamily);
  const category = font ? font.category : DEFAULT_CATEGORY;
  return `${fontFamily}, ${category}`;
};
